import React, { Suspense, lazy, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { ContentRoute, Layout, LayoutSplashScreen } from "../_metronic/layout";
import LoanConfigPage from "./pages/loan/loanConfigPage";
import Login from "./pages/login/login";

import { Backdrop, CircularProgress } from "@mui/material";
import CommentsTable from "./pages/comments/commentsTable";
import DashboardLoader from "./pages/dashboard/dashboardLoader/DashboardLoader";
import FavouriteDashboardSearch from "./pages/dashboard/favouriteDashboardSearch/favouriteDashboardSearch";
import ReportViewer from "./pages/dashboard/report/reportViewer";
import DashboardPanel from "./pages/dashboard/userDashboard/CRUDUserDashboard/dashboardPanel";
import UserDashboard from "./pages/dashboard/userDashboard/UserDashboard";
import ErrorPage from "./pages/errorPage/errorPage";
import PaymentConfigPage from "./pages/loan/paymentConfigPage";
import ReportConfigPage from "./pages/loan/reportConfigPage";
import SearchConfigPage from "./pages/loan/searchConfigPage";
import UserProfilePage from "./pages/loan/userProfilePage";
import Welcome from "./pages/loan/welcome";
import ForceToChangePassword from "./pages/login/forceToChangePassword";
import LoginByOtp from "./pages/login/loginByOtp";
import Otp from "./pages/login/otp";
import BodyMap from "./pages/map/bodyMap";
import AddNotification from "./pages/notification/addNotification";
import NotificationList from "./pages/notification/notificationList";
import DefineMenu from "./pages/permission/defineMenu";
import DefinePermission from "./pages/permission/definePermission";
import PermissionsChart from "./pages/permission/permissionsChart";
import PermissionReport from "./pages/permission/report";
import RolePermissionList from "./pages/permission/rolePermissionList";
import RolePermissionTabs from "./pages/permission/rolePermissionTabs";
import UserDetail from "./pages/permission/userDetail";
import UsersAccessList from "./pages/permission/usersAccessList";
import AddNewSupplierCmp from "./pages/reports/AddNewSupplier";
import FinancialSupplier from "./pages/reports/FinancialSupplier";
import FinancialSupplierDetail from "./pages/reports/FinancialSupplierDetail";
import FinancialSupplierDetailList from "./pages/reports/FinancialSupplierDetailList";
import LoanTemplateInfo from "./pages/reports/LoanTemplateInfo";
import SuppliersList from "./pages/reports/SuppliersList";
import SuppliersListDetail from "./pages/reports/SuppliersListDetail";
import CreateStore from "./pages/storeAndBranch/store/createStore";
import StoreConfigPage from "./pages/storeAndBranch/store/storeConfigPage";
import SettlementHistoryDetail from "./pages/supplierSettelments/SettlementHistoryDetail";
import StoreRequestDetail from "./pages/supplierSettelments/sepplierRequestDetail";
import SettelmentRequestsList from "./pages/supplierSettelments/settelmentRequestsList";
import SettelmentWithStoresList from "./pages/supplierSettelments/settelmentWithStoresList";
import SettlementHistory from "./pages/supplierSettelments/settlementHistory";
import SupplierSettementRequestDetail from "./pages/supplierSettelments/supplierSettementRequestDetail";
import SupplierBranches from "./pages/supplierUser/supplierBranches";
import SupplierUsers from "./pages/supplierUser/supplierUsers";
import UserRegistration from "./pages/supplierUser/userRegistration";
import Test from "./pages/test/test";
import { getTokenClaims } from "./services/auth.service";
import BranchRegister from "./pages/storeAndBranch/branch/branchRegister";
import BranchUserTable from "./pages/storeAndBranch/branch/branchUserTable";
import CustomerInfo from "./pages/customeInfo/customerInfo";
import CustomerInfoDetail from "./pages/customeInfo/customerInfoDetail";
import CancleLoanList from "./pages/cancleLoan/cancleLoanList";
import NotFound from "./components/error/NotFound";
import LoanPlansConfigPage from "./pages/loanPlans/loanPlansConfigPage";
import InstallmentRegistration from "./pages/customeInfo/installmentRegistration";

const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);

export default function BasePage() {
  const canModifyUser = String(getTokenClaims()?.canModifyUser);

  const [titleHeader, setTitleHeader] = useState<any>(undefined);

  return (
    <>
      <Backdrop
        hidden={true}
        sx={{ color: "#fff", zIndex: () => 10000 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/loginByOtp" component={LoginByOtp} />
        <Route path="/otp" component={Otp} />
        <Route path="/forceChangePass" component={ForceToChangePassword} />
        <Route path="/reportViewer" component={ReportViewer} />

        {/* <Route path="/reportPage/TableReportPage" component={TableReportPage} /> */}
        <Layout>
          <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
              <ContentRoute
                path="/"
                exact
                component={Welcome}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/test"
                component={Test}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/loan"
                component={LoanConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/store"
                component={StoreConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/setting/notificationList"
                component={NotificationList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/setting/supplierUsers"
                component={SupplierUsers}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/setting/UserRegistration"
                component={UserRegistration}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/setting/supplierBranches"
                component={SupplierBranches}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/SuppliersList/AddSupplier"
                component={AddNewSupplierCmp}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/Map"
                component={BodyMap}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/userDashboard"
                component={UserDashboard}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/dashboardPanel"
                component={DashboardPanel}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/favouriteDashboardSearch"
                component={FavouriteDashboardSearch}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/dashboadLoader"
                component={DashboardLoader}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/setting/AddNotification"
                component={AddNotification}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/profile"
                component={UserProfilePage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/Search"
                component={SearchConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/Report"
                component={ReportConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/welcome"
                component={Welcome}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/SuppliersList"
                component={SuppliersList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/SuppliersList1/SuppliersListDetail"
                component={SuppliersListDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/Payment"
                component={PaymentConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/FinancialSupplier"
                component={FinancialSupplier}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/FinancialSupplier1/FinancialSupplierDetailList"
                component={FinancialSupplierDetailList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail"
                component={FinancialSupplierDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail1/LoanTemplateInfo"
                component={LoanTemplateInfo}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/Comments/History"
                component={CommentsTable}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/PermissionsChart"
                component={PermissionsChart}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/UserDetail"
                component={UserDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/UsersAccessList"
                component={UsersAccessList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/UsersReport"
                component={PermissionReport}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/RolePermissionList"
                component={RolePermissionList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/RolePermissionTabs"
                component={RolePermissionTabs}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/DefineMenu"
                component={DefineMenu}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/DefinePermission"
                component={DefinePermission}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/SettelmentRequestsList"
                component={SettelmentRequestsList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/StoreRequestDetail"
                component={StoreRequestDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/SettelmentWithStoresList"
                component={SettelmentWithStoresList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/StoreSettementRequestDetail"
                component={SupplierSettementRequestDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/settlementHistory"
                component={SettlementHistory}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/settlementHistoryDetail"
                component={SettlementHistoryDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />

              <ContentRoute
                path="/CreateStore"
                component={CreateStore}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/BranchRegister"
                component={BranchRegister}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/BranchUserTable"
                component={BranchUserTable}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/CustomerInfoList"
                component={CustomerInfo}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/CustomerInfoDetail"
                component={CustomerInfoDetail}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/installmentRegistration"
                component={InstallmentRegistration}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/CancleLoanList"
                component={CancleLoanList}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/plans"
                component={LoanPlansConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />

              <ContentRoute
                path="/*"
                component={NotFound}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <Route path="/error" component={ErrorPage} />
              {/* <Redirect to="error/error-v1" /> */}
              {/* <Redirect push to="/loan-list" /> */}
            </Switch>
          </Suspense>
        </Layout>
      </Switch>
    </>
  );
}
